"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "2": "Bygning",
  "20": "Bygning, generelt",
  "21": "Grunn og fundamenter",
  "211": "Klargjøring av tomt",
  "212": "Byggegrop",
  "213": "Grunnforsterkning",
  "214": "Støttekonstruksjon",
  "215": "Pelefundamentering",
  "216": "Direkte fundamentering",
  "217": "Drenering",
  "218": "Utstyr og komplettering",
  "219": "Andre deler av grunn og fundamenter",
  "22": "Bæresystemer",
  "221": "Rammer",
  "222": "Søyler",
  "223": "Bjelker",
  "224": "Avstivende konstruksjoner",
  "225": "Brannbeskyttelse av bærende konstruksjoner",
  "226": "Kledning og overflate",
  "228": "Utstyr og komplettering",
  "229": "Andre deler av bæresystem",
  "23": "Yttervegger",
  "231": "Bærende yttervegger",
  "232": "Ikke-bærende yttervegger",
  "233": "Glassfasader",
  "234": "Vinduer, dører, porter",
  "235": "Utvendig klending og overflate",
  "236": "Invendig overflate",
  "237": "Solavskjerming",
  "238": "Utstyr og komplettering",
  "239": "Andre deler av yttervegg",
  "24": "Innervegger",
  "241": "Bærenede innervegger",
  "242": "Ikke-bærende innervegger",
  "243": "Systemvegger, glassfelt",
  "244": "Vinduer, dører, foldevegger",
  "245": "Skjørt",
  "246": "Kledning og overflate",
  "248": "Utstyr og komplettering",
  "249": "Andre deler av innervegg",
  "25": "Dekker",
  "251": "Frittbærende dekker",
  "252": "Gulv på grunn",
  "253": "Oppfõret gulv, påstøp",
  "254": "Gulvsystemer",
  "255": "Guloverflate",
  "256": "Faste himlinger og overflatebehandling",
  "257": "Systemhimlinger",
  "258": "Utstyr og komplettering",
  "259": "Andre deler og dekker",
  "26": "Yttertak",
  "261": "Primærkonstruksjoner",
  "262": "Taktekning",
  "263": "Glasstak, overlys, takluker",
  "264": "Takoppbygg",
  "265": "Gesimser, takrenner og nedløp",
  "266": "Himling og innvendig overflate",
  "267": "Prefabrikerte takelementer",
  "268": "Utstyr og komplettering",
  "269": "Andre deler av yttertak",
  "27": "Fast inventar",
  "271": "Murte piper og ildsteder",
  "272": "Monteringsferdige ildsteder",
  "273": "Kjøkkeninnredning",
  "274": "Innredning og garnityr for våtrom",
  "275": "Skap og reoler",
  "276": "Sittebenker, stolrader, bord",
  "277": "Skilt og tavler",
  "278": "Utstyr og komplettering",
  "279": "Annet fast inventar",
  "28": "Trapper, balkonger, m.m.",
  "281": "Innvendige trapper",
  "282": "Utvendige trapper",
  "283": "Ramper",
  "284": "Balkonger og verandaer",
  "285": "Tribuner og amfier",
  "286": "Baldakiner og skjermtak",
  "287": "Andre rekkverk, håndlister og fendere",
  "288": "Utstyr og kompletteringer",
  "289": "Andre trapper, balkonger m.m.",
  "29": "Andre bygningsmessige deler",
  "3": "VVS-installasjoner",
  "30": "VVS-installasjoner, generelt",
  "31": "Sanitær",
  "311": "Bunnledninger for sanitærinstallasjoner",
  "312": "Ledningsnett for sanitærinstallasjoner",
  "314": "Armatur for sanitærinstallasjoner",
  "315": "Utstyr for sanitærinstallasjoner",
  "316": "Isolasjon for sanitærinstallasjoner",
  "319": "Andre deler av sanitærinstallasjoner",
  "32": "Varme",
  "321": "Bunnledning for varmeinstallasjoner",
  "322": "Ledningsnett for varmeinstallasjoner",
  "324": "Armatur for varmeinstallasjoner",
  "325": "Utstyr for varmeinstallasjoner",
  "326": "Isolasjon for varmeinstallasjoner",
  "329": "Andre deler av varmeinstallasjoner",
  "33": "Brannslokking",
  "331": "Installasjon for manuell brannslokking med vann",
  "332": "Installasjon for brannslokking med sprinkler",
  "333": "Installasjon for brannslokking med vanntåke",
  "334": "Installasjon for brannslokking med pulver",
  "335": "Installasjon for brannslokking med inertgass",
  "339": "Andre deler av installasjoner for brannslokking",
  "34": "Gass og trykkluft",
  "341": "Installasjon til gass for bygningsdrift",
  "342": "Installasjon til gass for virksomhet i ferdig bygg",
  "343": "Installasjon til medisinske gasser",
  "345": "Installasjon til trykkluft for virksomhet i ferdig bygg",
  "346": "Installasjon til medisinsk trykkluft",
  "347": "Vakuumsystemer",
  "349": "Andre deler av installasjoner til gass- og trykkluft",
  "35": "Prosesskjøling",
  "351": "Kjøleromsystemer",
  "352": "Fryseromsystemer",
  "353": "Kjølesystemer for virksomhet",
  "354": "Kjølesystemer for produksjon",
  "355": "Kuldesystemer for innendørs idrettsbaner",
  "359": "Andre deler av installasjoner for kulde- og kjølesystemer",
  "36": "Luftbehandling",
  "361": "Kanalnett i grunnen for luftbehandling",
  "362": "Kanalnett for luftbehandling",
  "364": "Utstyr for luftfordeling",
  "365": "Utstyr for luftbehandling",
  "366": "Isolasjon av installasjon for luftbehandling",
  "369": "Annet utstyr for luftbehandling",
  "37": "Komfortkjøling",
  "371": "Ledningsnett i grunnen for komfortkjøling",
  "372": "Ledningsnett for komfortkjøling",
  "374": "Armaturer for komfortkjøling",
  "375": "Utstyr for komfortkjøling",
  "376": "Isolasjon av installasjon for komfortkjøling",
  "379": "Andre deler for komfortkjøling",
  "38": "Vannbehandling",
  "381": "Systemer for rensing av forbruksvann",
  "382": "Systemer for rensing av avløpsvann",
  "383": "Systemer for rensing av vann til svømmebasseng",
  "386": "Innendørs fontener og springvann",
  "389": "Andre deler for vannbehandling",
  "39": "Andre VVS-installasjoner",
  "4": "Elkraft",
  "40": "Elkraft, generelt",
  "41": "Basisinstallasjon for elkraft",
  "411": "Basisinstallasjon for elkraft» Systemer for kabelføring",
  "412": "Basisinstallasjon for elkraft» Systemer for jording",
  "413": "Basisinstallasjon for elkraft» Systemer for lynvern",
  "414": "Basisinstallasjon for elkraft» Systemer for elkraftuttak",
  "419": "Basisinstallasjon for elkraft» Andre basisinstallasjoner for elkraft",
  "42": "Høyspent forsyning",
  "421": "Fordelingssystemer",
  "422": "Nettstasjoner",
  "429": "Andre deler for høyspent forsyning",
  "43": "Lavspent forsyning",
  "431": "System for elkraftinntak",
  "432": "Systemer for hovedfordeling",
  "433": "Elkraftfordeling til alminnelig forbruk",
  "434": "Elkraftfordeling til driftstekniske installasjoner",
  "435": "Elkraftfordeling til virksomhet",
  "439": "Andre deler for lavspent forsyning",
  "44": "Lys",
  "442": "Belysningsutstyr",
  "443": "Nødlysutstyr",
  "449": "Andre deler for installasjoner til lys",
  "45": "Elvarme",
  "452": "Varmeovner",
  "453": "Varmeelementer for innebygging",
  "454": "Vannvarme og elektrokjeler",
  "459": "Annen elvarme",
  "46": "Reservekraft",
  "461": "Elkraftaggregater",
  "462": "Avbruddsfri kraftforsyning",
  "463": "Akkumulatoranlegg",
  "469": "Andre deler for reservekraftforsyning",
  "49": "Andre kraftinstallasjoner",
  "5": "Tele og automatisering",
  "50": "Tele og automatisering, generelt",
  "51": "Basisintallasjon for tele og automatisering",
  "511": "Systemer for kabelføring",
  "512": "Jording",
  "514": "Intakskabler for teleanlegg",
  "515": "Telefordelinger",
  "519": "Andre basisinstallasjoner for tele og automatisering",
  "52": "Integrert kommunikasjon",
  "521": "Kabling for IKT",
  "522": "Nettutstyr",
  "523": "Sentralutstyr",
  "524": "Terminalutstyr",
  "529": "Andre deler for integrert kommunikasjon",
  "53": "Telefoni og personsøkning",
  "532": "Systemer for telefoni",
  "534": "Systemer for porttelefoner",
  "535": "Systemer for høyttalende hustelefoner",
  "536": "Systemer for personsøkning",
  "539": "Andre deler for telefoni og personsøkning",
  "54": "Alarm og signal",
  "542": "Brannalarm",
  "543": "Adgangskontroll, innbrudds- og overfallsalarm",
  "544": "Pasientsignal",
  "545": "Uranlegg og tidsregistrering",
  "549": "Andre deler for alarm og signal",
  "55": "Lyd og bilde",
  "552": "Fellesantenne",
  "553": "Internfjernsyn",
  "554": "Lyddistribusjonsanlegg",
  "555": "Lydanlegg",
  "556": "Bilde og AV-systemer",
  "559": "Andre deler for lyd- og bildesystemer",
  "56": "Automatisering",
  "562": "Sentral driftskontroll og automatisering",
  "563": "Lokal automatisering",
  "564": "Buss-systemer",
  "565": "FDVUS Administrative systemer",
  "569": "Andre deler for automatisering",
  "57": "Instrumentering",
  "571": "Kabling for instrumentering",
  "572": "Instrumentering for måling av mengde",
  "573": "Instrumentering for måling av trykk",
  "574": "Instrumentering for måling av temperatur",
  "575": "Instrumentering for måling av lengde",
  "576": "Instrumentering for måling av vekt",
  "577": "Instrumentering for måling av elektriske størrelser",
  "578": "Instrumentering for analyse",
  "579": "Annen instrumentering",
  "59": "Andre installasjoner for tele og automatiseringer",
  "6": "Andre installasjoner",
  "60": "Andre installasjoner, generelt",
  "61": "Prefabrikert rom",
  "611": "Prefabrikerte kjølerom",
  "612": "Prefabrikerte fryserom",
  "613": "Prefabrikerte baderom",
  "614": "Prefabrikerte skjermrom",
  "615": "Prefabrikerte sjakter",
  "619": "Andre prefabrikerte rom",
  "62": "Person- og varetransport",
  "621": "Heiser",
  "622": "Rulletrapper",
  "623": "Rullebånd",
  "624": "Løftebord",
  "625": "Trappeheiser",
  "626": "Kraner",
  "627": "Fasade- og takvask",
  "629": "Annen person- og varetransport",
  "63": "Transportanlegg for småvarer m.v.",
  "631": "Dokument- og småvaretransportører",
  "632": "Transportanlegg for tørr og løs masse",
  "639": "Andre transportanlegg for småvarer mv.",
  "64": "Sceneteknisk utstyr",
  "65": "Avfall og støvsuging",
  "651": "Utstyr for oppsamling og behandling av avfall",
  "652": "Sentralstøvsuger",
  "653": "Pneumatisk søppeltransport",
  "659": "Andre installasjoner for avfall og støvsuging",
  "66": "Fasmontert spesialutrustning for virksomhet",
  "67": "Løs spesialutrustning for virksomhet",
  "69": "Andre tekniske installasjoner",
  "7": "Utendørs",
  "70": "Utendørs, generelt",
  "71": "Bearbeidet terreng",
  "711": "Grovplanert terreng",
  "712": "Drenering",
  "713": "Forsterket grunn",
  "714": "Grøfter og groper for tekniske installasjoner",
  "719": "Annen terrengbearbeiding",
  "72": "Utendørs konstruksjoner",
  "721": "Støttemurer og andre murer",
  "722": "Trapper og ramper i terreng",
  "723": "Frittstående skjermtak, leskur mv.",
  "724": "Svømmebassenger mv.",
  "725": "Gjerder, porter og bommer",
  "726": "Kanaler og kulverter for tekniske installasjoner",
  "727": "Kummer og tanker for tekniske installasjoner",
  "729": "Andre utendørs konstruksjoner",
  "73": "Utendørs VVS",
  "731": "Utendørs VA",
  "732": "Utendørs varme",
  "733": "Utendørs brannslokking",
  "734": "Utendørs gassinstallasjoner",
  "735": "Utendørs kjøling for idrettsbaner",
  "736": "Utendørs luftbehandlingsanlegg",
  "737": "Utendørs forsyningsanlegg for termisk energi",
  "738": "Utendørs fontener og springvann",
  "739": "Andre utendørs røranlegg",
  "74": "Utendørs elkraft",
  "742": "Utendørs høyspent forsyning",
  "743": "Utendørs lavspent forsyning",
  "744": "Utendørs lys",
  "745": "Utendørs elvarme",
  "746": "Utendørs reservekraft",
  "749": "Andre installasjoner for utendørs elkraft",
  "75": "Utendørs tele og automatisering",
  "752": "Utendørs integrert kommunikasjon",
  "753": "Utendørs telefoni og personsøkning",
  "754": "Utendørs alarm og signal",
  "755": "Utendørs lyd og bilde",
  "756": "Utendørs automatisering",
  "759": "Andre installasjoner for utendørs tele og automatisering",
  "76": "Veger og plasser",
  "761": "Veger",
  "762": "Plasser",
  "763": "Skilter",
  "764": "Sikkerhetsrekkverk, avvisere mv.",
  "769": "Andre deler for veger og plasser",
  "77": "Park og hage",
  "771": "Gressarealer",
  "772": "Beplantning",
  "773": "Utstyr",
  "779": "Andre deler for parker og hager",
  "78": "Utendørs infrastruktur",
  "783": "Tilknytning til eksterne nett for vannforsyning, avløp og fjernvarme",
  "784": "Tilknytning til eksternt elkraftnett",
  "785": "Tilknytning til eksternt telenett",
  "789": "Andre deler for utendørs infrastuktur",
  "79": "Andre utendørs anlegg"
};
exports.default = _default;
module.exports = exports.default;